import { ExternalProductSearch } from '@/@types';

const KEY = '910a392eb27e70465e995baa520c7245';

type AvailableTypes = 'movie' | 'tv';

const _request = async ({ url, method = 'GET', params, data }: { url: string; method?: string; params?: any; data?: any }) => {
  const queryString = new URLSearchParams({
    api_key: KEY,
    ...params,
  }).toString();

  const makeRequest = () => {
    return fetch(`https://api.themoviedb.org${url}?${queryString}`, {
      body: JSON.stringify(data),
      method,
    }).then((res) => {
      return res.json();
    });
  };
  return makeRequest();
};

const parseItem = (item) => {
  return {
    name: item.original_title || item.original_name,
    externalId: item.id,
    details: item.overview,
    image: `https://image.tmdb.org/t/p/w220_and_h330_face${item.poster_path}`,
  } as ExternalProductSearch;
};

const movieDB = () => {
  return {
    _request,
    suggestions: async ({ type }: { type: AvailableTypes }): Promise<ExternalProductSearch[]> => {
      return _request({
        url: `/3/discover/${type}`,
        params: {
          sort_by: 'popularity.desc',
          include_adult: false,
          include_video: false,
          page: 1,
        },
      }).then(({ results }) => {
        return results.map(parseItem);
      });
    },
    search: async ({ type, query }: { type: AvailableTypes; query: string }): Promise<ExternalProductSearch[]> => {
      return _request({
        url: `/3/search/${type}`,
        params: { query },
      }).then(({ results }) => {
        return results.map(parseItem);
      });
    },
  };
};

export default movieDB;
